import { CSSProperties } from "react";
import * as colors from "./colors";

export const hFormStyle: CSSProperties = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: 9
};

export const vFormStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    rowGap: 9
};

export const hFieldStyle: CSSProperties = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: 9
};

export const vFieldStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    rowGap: 9
};

export const hLabelStyle: CSSProperties = {
    flex: "0 0 auto",
    textAlign: "right",
    minWidth: 200
};
export const hInputStyle: CSSProperties = {
    flex: "1"
};